import { FunctionComponent, useContext, useEffect } from "react";

//OpenLayers
import { DragBox } from "ol/interaction";

//Custom components
import MapContext from "@/components/Map/MapContext";
import { registerOlInteraction } from "@/lib/olHelpers";

//Types
import { MapContextType } from "@/@types/context/MapContext";

const DragBoxInteraction: FunctionComponent<any> = (props) => {
  const context = useContext(MapContext) as MapContextType;

  const options = {
    className: undefined,
    condition: undefined,
    minArea: undefined,
    boxEndCondition: undefined,
    onBoxEnd: undefined
  };

  const events = {
    boxdrag: undefined,
    boxend: undefined,
    boxstart: undefined,
    change: undefined,
    "change:active": undefined,
    error: undefined,
    propertychange: undefined
  };

  useEffect(
    () =>
      registerOlInteraction(context, DragBox, props, options, events),
    []
  );

  return null;
};

export default DragBoxInteraction;

